import _ from 'lodash';
import moment from 'moment';
import constants from '@/constants.js';

class DateRangeSelectionService {
    getDefaultQuickSelection (dateQuickSelections) {
        // Setting default selection as Last 90 Days.
        let defaultQuickSelection = _.find(dateQuickSelections, qs => qs.type.key === constants.DATE_QUICK_SELECTIONS.LAST_NINETY_DAYS.key);

        // check if the selected quick selection is not enabled then select the next enabled one.
        if (!defaultQuickSelection || !defaultQuickSelection.enabled) {
            let enabledQuickSelections = _(dateQuickSelections)
                .filter(qs => qs.enabled && qs.type.key !== constants.DATE_QUICK_SELECTIONS.CUSTOM.key)
                .sortBy('type.order')
                .reverse()
                .value();
            defaultQuickSelection = enabledQuickSelections.length > 0 ? enabledQuickSelections[0] : null;
        }

        // If non of the quick selection is enabled then select the custom selection
        if (!defaultQuickSelection) {
            defaultQuickSelection = _.find(dateQuickSelections, qs => qs.type.key === constants.DATE_QUICK_SELECTIONS.CUSTOM.key);
        }

        return defaultQuickSelection;
    }

    buildDateQuickSelections (startDate, endDate) {
        let date = endDate;

        let lastSevenDays = {
            type: constants.DATE_QUICK_SELECTIONS.LAST_SEVEN_DAYS,
            startDate: moment(date).subtract(6, 'day').toDate(),
            endDate: date
        };

        let lastThirtyDays = {
            type: constants.DATE_QUICK_SELECTIONS.LAST_THIRTY_DAYS,
            startDate: moment(date).subtract(29, 'day').toDate(),
            endDate: date
        };

        let lastNinetyDays = {
            type: constants.DATE_QUICK_SELECTIONS.LAST_NINETY_DAYS,
            startDate: moment(date).subtract(89, 'day').toDate(),
            endDate: date
        };

        let lastOneHundredEightyDays = {
            type: constants.DATE_QUICK_SELECTIONS.LAST_ONE_HUNDRED_EIGHTY_DAYS,
            startDate: moment(date).subtract(179, 'day').toDate(),
            endDate: date
        };

        // Set the selectability of these selection types
        // Moment documentation: A [ indicates inclusion of a value. A ( indicates exclusion.
        // Please check moment documentation for detailed explanation is 'isBetween' function. https://momentjs.com/docs/#/query/
        lastSevenDays.enabled = moment(lastSevenDays.startDate).isBetween(startDate, endDate, 'day', '[]');
        lastThirtyDays.enabled = moment(lastThirtyDays.startDate).isBetween(startDate, endDate, 'day', '[]');
        lastNinetyDays.enabled = moment(lastNinetyDays.startDate).isBetween(startDate, endDate, 'day', '[]');
        lastOneHundredEightyDays.enabled = moment(lastOneHundredEightyDays.startDate).isBetween(startDate, endDate, 'day', '[]');

        let customSelection = {
            type: constants.DATE_QUICK_SELECTIONS.CUSTOM,
            startDate: startDate,
            endDate: endDate,
            enabled: true
        };

        return [lastSevenDays, lastThirtyDays, lastNinetyDays, lastOneHundredEightyDays, customSelection];
    }
};

export const dateRangeSelectionService = new DateRangeSelectionService();
